import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";

export const getSGPILists = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(API_ENDPOINTS.SGPI.GET_SGPI_LISTS, {
    params: params,
  });

  console.log("🚀 ~ SGPIRepository.ts:10 ~ getSGPILists ~ response:", response);

  return response?.data;
};

// GET_TRANSACTION_LIST

export const getTransactionList = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.SGPI.GET_TRANSACTION_LIST,
    { params: params }
  );

  console.log(
    "🚀 ~ MaterialRepo.ts:118 ~ getTransactionList ~ response:",
    response
  );

  return response?.data;
};

export const getSGPIBalanceList = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.SGPI.GET_BALANCE_SGPI_LISTS,
    { params: params }
  );

  console.log(
    "🚀 ~ MaterialRepo.ts:132 ~ getSGPIBalanceList ~ response:",
    response
  );

  return response?.data;
};

export const getSGPIStatus = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(API_ENDPOINTS.SGPI.GET_SGPI_STATUS);

  console.log("🚀 ~ SGPIRepository.ts:48 ~ getSGPIStaus ~ response:", response);

  return response?.data;
};

export const addSGPITransaction = async (body?: Record<string, any>) => {
  const response = await axiosInstance.post(
    API_ENDPOINTS.SGPI.ADD_TRANSACTION,
    body
  );

  return response?.data;
};

// ADD_SGPI
export const addSGPI = async (body?: any) => {
  const response = await axiosInstance.post(API_ENDPOINTS.SGPI.ADD_SGPI, body);

  console.log("🚀 ~ SGPIRepository.ts:66 ~ addSGPI ~ response:", response);

  return response?.data;
};
// GET_SGPI_FILTER
export const getSGPIFilter = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(API_ENDPOINTS.SGPI.GET_SGPI_FILTER, {
    params: params,
  });

  console.log(
    "🚀 ~ SGPIRepository.ts:75 ~ getSGPIFilter ~ response:",
    response
  );

  return response?.data;
};
export const getSGPIAccountFilter = async (params?: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.SGPI.GET_SGPI_ACCOUNT_FILTER,
    {
      params: params,
    }
  );

  console.log(
    "🚀 ~ SGPIRepository.ts:87 ~ getSGPIAccountFilter ~ response:",
    response
  );

  return response?.data;
};

// UPDATE_SGPI_TRANSACTION
export const updateSGPITransaction = async (
  id?: string | number,
  body?: Record<string, any>
) => {
  const response = await axiosInstance.put(
    `${API_ENDPOINTS.SGPI.UPDATE_SGPI_TRANSACTION}/${id}`,
    body
  );

  console.log(
    "🚀 ~ SGPIRepository.ts:108 ~ updateSGPITransaction ~ response:",
    response
  );

  return response?.data;
};

// UPDATE_SGPI
export const updateSGPI = async (
  id?: string | number,
  body?: Record<string, any>
) => {
  const response = await axiosInstance.put(
    `${API_ENDPOINTS.SGPI.UPDATE_SGPI}/${id}`,
    body
  );

  console.log("🚀 ~ SGPIRepository.ts:126 ~ updateSGPI ~ response:", response);

  return response?.data;
};
